import * as Types from '@/types';

import { gql } from '@apollo/client';
export const CompleteTranslationFieldsFragmentDoc = gql`
  fragment CompleteTranslationFields on CompleteTranslation {
    en
    es
    fr
    zh
  }
`;
